<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">school</v-icon>
			<v-toolbar-title>Wykształcenie</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Wykształcenie</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-select
						:readonly="readOnlyMode"
						:items="educationGrades"
						v-model="data.grade"
						aria-label="education grade"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						v-model="data.description"
						label="Wykształcenie"
						aria-label="education"
						for="education-profile-data-view-education"
						id="education-profile-data-view-education"
						outline
					></v-textarea>
				</v-flex>
			</v-layout>

			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Języki</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-select
						:readonly="readOnlyMode"
						:items="languages"
						label="Język"
						aria-label="language"
						for="education-profile-data-view-language"
						id="education-profile-data-view-language"
						item-value="id"
						item-text="name"
						v-model="language.dictionaryId"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-text-field
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						label="Certyfikat znajomości języka"
						aria-label="language certificate"
						for="education-profile-data-view-language-certificate"
						id="education-profile-data-view-language-certificate"
						v-model="language.certificate"
					></v-text-field>
				</v-flex>
				<v-flex xs3>
				</v-flex>
			</v-layout>

			<v-layout row>
				<v-flex xs4/>
				<v-flex xs3>
					<v-btn v-if="editable" block @click="addLanguage" color="primary" class="white--text mb-5"
						:disabled="readOnlyMode">
						Dodaj język
					</v-btn>
				</v-flex>
			</v-layout>

			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-data-table
						v-if="data.languages !== undefined && data.languages.length > 0"
						:items="data.languages"
						hide-headers
						hide-actions>
						<template slot="items" slot-scope="props">
							<td class="text-xs-center">{{ props.item.name}}</td>
							<td class="text-xs-center">{{ props.item.certificate}}</td>
							<td class="text-xs-center">
								<v-layout align-center justify-center column>
									<v-btn
										v-if="editable"
										@click="removeLanguage(props.item)"
										color="grey lighten-3"
										:disabled="readOnlyMode"
										class="grey--text text--darken-2">
										Usuń język
									</v-btn>
								</v-layout>
							</td>
						</template>
					</v-data-table>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	import {VolunteerLanguage} from "../../../../../api/generated/VolunteerLanguage";

	export default {
		name: "EducationProfileDataView",

		data() {
			return {
				educationGrades: [
					"brak",
					"średnie",
					"wyższe",
				],

				language: {
					dictionaryId: "",
					name: "",
					certificate: "",
				},

				languages: [],

				readOnlyMode: true,

				data: {},
			};
		},

		methods: {
			addLanguage() {
				if (this.language.dictionaryId === "" || this.language.dictionaryId === undefined ||
					this.data.languages.find(el => el.dictionaryId === this.language.dictionaryId) !== undefined) return;
				let newLanguage = Object.assign({}, this.language);
				newLanguage.name = this.languages.find(el => el.id === this.language.dictionaryId).name;
				this.data.languages.push(newLanguage);
				this.language.dictionaryId = undefined;
				this.language.name = "";
				this.language.certificate = "";
			},

			removeLanguage(language) {
				const index = this.data.languages.indexOf(language);
				this.data.languages.splice(index, 1);
			},
		},

		watch: {
			educationData: function () {
				this.data = this.educationData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		created() {
			VolunteerLanguage.getRegistrationLanguages(this, successResponse => {
				this.languages = successResponse;
			}, errorResponse => {
				this.$messagesBus.$emit("error", "Nie udało się załadować listę języków", errorResponse);
			});
		},

		props: {
			educationData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>
	.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
		background-color: #0052a5 !important;
	}
</style>